import React from "react";
import { Route } from "react-router-dom";

import Dashboard from "components/Dashboard";

const Overview = () => <Route path="/" component={() => <Dashboard />} />;

export default Overview;
